export function getRoleLabel(role: string): string {
  switch (role) {
    case "primary_owner":
    case "owner":
      return "Owner";
    case "admin":
      return "Admin";
    case "collaborator":
      return "Collaborator";
    default:
      return "Member";
  }
}
